import { render } from "./TheBarChart.vue?vue&type=template&id=6f9af2ec"
import script from "./TheBarChart.vue?vue&type=script&lang=js"
export * from "./TheBarChart.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Softwaresul\\Projetos\\LWP\\Nil Recruiter\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__